import React, { useEffect, useContext } from "react";
import { Route, withRouter } from "react-router-dom";
import SurveyBlockModal from "../components/shared/modals/SurveyBlockModal";
import Loading from "../components/shared/Loading";

import StudentContext from './../context/student-context';

const PrivateRoute = ({ component: Component, path, navBar, ...rest }) => {

    const { loginWithRedirect, studentContext } = useContext(StudentContext);

    useEffect(() => {
        const fn = async () => {
            if (localStorage.getItem("code") ? false : true) {
                await loginWithRedirect();
            }
        };
        fn();   
    }, [loginWithRedirect, path]);

    // return <Route path={path} {...rest} />;

    if(!studentContext){
        return <Loading/>
    }
    if(studentContext.gated.loading){
        return <Loading/>
    }
    if(!studentContext.gated.gated || path == "/Survey" || path == "/SurveyQuestionList")
    {
        return <Route path={path} {...rest} />;
    }
    else{
        return <SurveyBlockModal/>;
    }
};

export default withRouter(PrivateRoute);